import { useQuery } from '@tanstack/react-query';

import { CalendarEventModel } from '@/types/calendar';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { getResolvedEndpoint } from '@/api/utils/getResolvedEndpoint';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

import { AICalendarEvent } from './useGetAICalendarEvents';

export interface CalendarEventsQueryParams {
  property_location_id: number;
  start_date?: string;
  end_date?: string;
}

export interface CalendarEventsResponse {
  events: CalendarEventModel[];
  aiEvents: AICalendarEvent[]; // Use the appropriate type
}

const METHOD = 'GET';
const ENDPOINT = 'calendar-events/all';
export const QUERY_KEY = (params: CalendarEventsQueryParams) =>
  getQueryKey(METHOD, ENDPOINT, params);

export const useGetAllCalendarEvents = (params: CalendarEventsQueryParams, enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(params),
    queryFn: async () => {
      const data = await handleApiCall<CalendarEventsResponse>(
        session,
        METHOD,
        getResolvedEndpoint(ENDPOINT, {}),
        undefined,
        { params }
      );

      return data;
    },
  });
};
